export const CONTACT_DB_HEADER_NAME = "x-contact-db";
export const CONTACT_DB_HEADERS: Record<string, string> = { "x-contact-db": "true" };
export const POST_JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json; charset=utf-8",
};
export const MAX_GUIDS_F5_SUPPORTED = 20;
